import React, { useState, useContext } from 'react';
import AuthContext from 'context/AuthProvider';
import Toast from 'light-toast';
import {
    USER_ICON,
    SIGN_OUT_ICON,
    PROGRAM_ICON,
    STEPS_ICON,
    BAR_ICON,
    TIMES_CIRCLE_ICON,
    USER_PLUS_ICON,
    METER_ICON,
    EMPLOYER,
    SETTINGS,
    BOM_ICON,
    HISTORY_ICON,
    QUICK_UPDATE,
    DELIVERY_ICON,
} from 'assets/constants/Icons';
import {
    ProSidebar,
    Menu,
    MenuItem,
    SidebarHeader,
    SidebarContent,
    SidebarFooter,
    SubMenu,
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { hasRoutePermission } from 'components/Permission';
import {
    SpaceDashboardIcon,
    BusinessIcon,
    ContactMailIcon,
    FormatListNumberedIcon,
    FlashOnIcon,
    HandymanIcon
} from 'assets/constants/Icons';

function SideNavigationBar(props) {
    const authContext = useContext(AuthContext);
    const userDetail = JSON.parse(localStorage.getItem('userData'));
    const userRole = JSON.parse(localStorage.getItem('userRole'));
    const [menuCollapse, setMenuCollapse] = useState(true);
    const [hideNavbar] = useState(window.location.href.includes('/step-complete') ? true : false);

    const editUserHandler = (userDetail) => {
        props.history.push({
            pathname: '/create-user-page',
            state: { ...userDetail, isFromProfile: true },
        });
    };

    const menuIconClick = () => {
        menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);

        if (!authContext.isAuthenticated()) {
            Toast.fail('You are not logged in. Please Login!', 3000, () => {
                window.location.href = '/login-page';
            });
        }
    };

    return (
        userDetail && (
            <div className={`side-navigation-bar ${hideNavbar === true ? 'disaplay-none' : ''}`}>
                <div className="side-navigation-bar-hamburger-button" onClick={menuIconClick}>
                    {menuCollapse && (
                        <span
                            className={`${BAR_ICON} side-navigation-bar-icon`}
                            style={{marginTop: "8px", marginBottom: "8px"}}
                            aria-hidden="true"
                        ></span>
                    )}
                    {!menuCollapse && (
                        <span
                            className={`${TIMES_CIRCLE_ICON} side-navigation-bar-icon`}
                            style={{marginTop: "8px", marginBottom: "8px"}}
                            aria-hidden="true"
                        ></span>
                    )}
                </div>
                <div className="side-navigation-bar-content side-navbar-responsive">
                    <ProSidebar collapsed={menuCollapse} breakPoint="md" rtl={false}>
                        <SidebarHeader>
                            {userDetail && (
                                <Menu iconShape="circle">
                                    <MenuItem
                                        icon={
                                            <i
                                                className={`${USER_ICON} side-navigation-bar-icon`}
                                            ></i>
                                        }
                                        onClick={() => editUserHandler(userDetail)}
                                        title="Edit user information"
                                    >
                                        <span>{`Hi, ${userDetail.first_name} `}</span>
                                        <span>{`(${userRole.user_role})`}</span>
                                    </MenuItem>
                                </Menu>
                            )}
                        </SidebarHeader>

                        <SidebarContent>
                            <Menu iconShape="square">
                                {hasRoutePermission('/admin-dashboard-page') && (
                                    <MenuItem
                                        icon={
                                            <SpaceDashboardIcon className="mui-side-icon"  aria-hidden="true" />
                                        }
                                        title="Admin Dashboard"
                                    >
                                        <a
                                            className="side-navigation-bar-menu-title"
                                            href="/admin-dashboard-page"
                                        >
                                            Admin Dashboard
                                        </a>
                                    </MenuItem>
                                )}
                                {/* {
                                    userDetail && userDetail.employer_id &&(
                                        hasRoutePermission("/employer-dashboard-page") && (
                                            <MenuItem icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Employer Dashboard">
                                                <a className="side-navigation-bar-menu-title" href="/employer-dashboard-page">Employer Dashboard</a>
                                            </MenuItem>
                                        )  
                                    )
                                } */}
                                {/* {
                                    userDetail && userDetail.partner_id &&(
                                        hasRoutePermission("/partner-dashboard-page") && (
                                            <MenuItem icon={<i className={`${METER_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Partner Dashboard">
                                                <a className="side-navigation-bar-menu-title" href="/partner-dashboard-page">Partner Dashboard</a>
                                            </MenuItem>
                                        )  
                                    )
                                } */}
                                {/* BOM Menu Item - Always visible for debugging */}
                                <MenuItem
                                    icon={
                                        <FormatListNumberedIcon className="mui-side-icon"  aria-hidden="true" />
                                    }
                                    title="BOM"
                                >
                                    <a className="side-navigation-bar-menu-title" href="/bom-list">
                                        BOM
                                    </a>
                                </MenuItem>

                                {/* {hasRoutePermission('/delivery-trail-dashboard') && (
                                    <MenuItem
                                        icon={
                                            <i
                                                className={`${DELIVERY_ICON} side-navigation-bar-icon`}
                                                aria-hidden="true"
                                            ></i>
                                        }
                                        title="Delivery Trail"
                                    >
                                        <a
                                            className="side-navigation-bar-menu-title"
                                            href="/delivery-trail-dashboard"
                                        >
                                            Delivery Trail
                                        </a>
                                    </MenuItem>
                                )} */}

                                {/* Debug info in console */}
                                {(() => {
                                    const hasBomPermission = hasRoutePermission('/bom-list');
                                    return null; // Don't render anything, just log
                                })()}
                                {
                                    hasRoutePermission('/customer-list-page') && (
                                    <MenuItem
                                        icon={
                                            <ContactMailIcon className="mui-side-icon"  aria-hidden="true" />
                                        }
                                        title="Customer List"
                                    >
                                        <a
                                            className="side-navigation-bar-menu-title"
                                            href="/customer-list-page"
                                        >
                                            Customer List
                                        </a>
                                    </MenuItem>
                                )}
                                 {
                                    hasRoutePermission("/audit-trail-page") && (
                                        <MenuItem icon={<i className={`${HISTORY_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="History Page">
                                            <a className="side-navigation-bar-menu-title" href="/audit-trail-page">History</a>
                                        </MenuItem>
                                    )
                                }
                                {
                                    hasRoutePermission("/manufacturing-quick-update") && (
                                        <MenuItem icon={
                                        <FlashOnIcon className="mui-side-icon"  aria-hidden="true" />
                                        } title="Quick Update">
                                            <a className="side-navigation-bar-menu-title" href="/manufacturing-quick-update">Quick Update</a>
                                        </MenuItem>
                                    )
                                }
                                {/* {
                                    hasRoutePermission("/partner-page") && (
                                        <MenuItem icon={<i className={`${TRAININGPART} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Training Partner">
                                            <a className="side-navigation-bar-menu-title" href="/partner-page">Training Partner</a>
                                        </MenuItem>
                                    )
                                } */}
                                {/* {
                                    hasRoutePermission("/candidate-page") && (
                                        <MenuItem icon={<i className={`${USERS_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Candidate">
                                            <a className="side-navigation-bar-menu-title" href="/candidate-page">Candidate</a>
                                        </MenuItem>
                                    )
                                }
                                {
                                    (hasRoutePermission("/attendance-page") ||  hasRoutePermission("/attendance-report"))&& (
                                        <SubMenu id="side-navigation-bar-sub-menu-user" className={menuCollapse === true ? `side-navigation-bar-sub-menu-user` : ""} icon={<i className={`${CALENDAR_CHECK_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Attendance">
                                            {
                                                hasRoutePermission("/attendance-page") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="/attendance-page"> Attendance Page</a>
                                                    </MenuItem>
                                                )
                                            }
                                            {
                                                hasRoutePermission("/attendance-report") && (
                                                    <MenuItem>
                                                        <a className="side-navigation-bar-menu-title" href="/attendance-report">Attendance Report</a>
                                                    </MenuItem>
                                                )
                                            }
                                        </SubMenu>
                                    )
                                } */}
                                <SidebarFooter>
                                    <Menu>
                                        {
                                          hasRoutePermission('/std-process-page') && (
                                            <SubMenu
                                                id="side-navigation-bar-sub-menu-user"
                                                className={
                                                    menuCollapse === true
                                                        ? `side-navigation-bar-sub-menu-user`
                                                        : ''
                                                }
                                                icon={
                                                    <i
                                                        className={`${STEPS_ICON} side-navigation-bar-icon`}
                                                        aria-hidden="true"
                                                    ></i>
                                                }
                                                title="Processes"
                                            >
                                               {  hasRoutePermission('/std-process-page') && (
                                                <MenuItem>
                                                    <a
                                                        className="side-navigation-bar-menu-title"
                                                        href="/std-process-page"
                                                    >
                                                        Standard Processes
                                                    </a>
                                                </MenuItem>
                                               )}
                                                {hasRoutePermission('/step-list-page') && (
                                                    <MenuItem>
                                                        <a
                                                            className="side-navigation-bar-menu-title"
                                                            href="/step-list-page"
                                                        >
                                                            Process Steps
                                                        </a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>
                                        )}
                                    </Menu>
                                </SidebarFooter>
                                    {hasRoutePermission('/component-parts-page') && (
                                        <MenuItem icon={
                                            <HandymanIcon className="mui-side-icon"  aria-hidden="true" />
                                            } title="Component Parts">
                                            <a
                                                className="side-navigation-bar-menu-title"
                                                href="/component-parts-page"
                                            >
                                                Parts
                                            </a>
                                        </MenuItem>
                                    )} 
                                    {/* {  hasRoutePermission('/roles-page') && (
                                        <MenuItem
                                            icon={
                                                <i
                                                    className={`${STEPS_ICON} side-navigation-bar-icon`}
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                            title="Std Processes"
                                        >
                                            <a
                                                className="side-navigation-bar-menu-title"
                                                href="/std-process-page"
                                            >
                                                Std Processes
                                            </a>
                                        </MenuItem>
                                    )}
                                    {hasRoutePermission('/roles-page') && (
                                        <MenuItem
                                            icon={
                                                <i
                                                    className={`${STEPS_ICON} side-navigation-bar-icon`}
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                            title="Project Steps"
                                        >
                                            <a
                                                className="side-navigation-bar-menu-title"
                                                href="/step-list-page"
                                            >
                                                Process Steps
                                            </a>
                                        </MenuItem>
                                    )} */}
                                </Menu>

                            <SidebarFooter>
                                    <Menu>
                                        {hasRoutePermission('/user-page') && (
                                            <SubMenu
                                                id="side-navigation-bar-sub-menu-user"
                                                className={
                                                    menuCollapse === true
                                                        ? `side-navigation-bar-sub-menu-user`
                                                        : ''
                                                }
                                                icon={
                                                    <i
                                                        className={`${USER_PLUS_ICON} side-navigation-bar-icon`}
                                                        aria-hidden="true"
                                                    ></i>
                                                }
                                                title="User"
                                            >
                                                <MenuItem>
                                                    <a
                                                        className="side-navigation-bar-menu-title"
                                                        href="/user-page"
                                                    >
                                                        {' '}
                                                        User Master
                                                    </a>
                                                </MenuItem>
                                                {hasRoutePermission('/roles-page') && (
                                                    <MenuItem>
                                                        <a
                                                            className="side-navigation-bar-menu-title"
                                                            href="/roles-page"
                                                        >
                                                            Role
                                                        </a>
                                                    </MenuItem>
                                                )}
                                            </SubMenu>
                                        )}
                                    </Menu>
                                </SidebarFooter>
                            <SidebarFooter>
                                <Menu>
                                    {/* <MenuItem icon={<i className={`${PLUS_SQUARE_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Step Creation">
                                    <a className="side-navigation-bar-menu-title" href="/create-step-page">Step Creation</a>
                                </MenuItem> */}
                                    {/* <MenuItem icon={<i className={`${STEPS_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Project Steps">
                                        <a className="side-navigation-bar-menu-title" href="/step-list-page">Project Steps</a>
                                    </MenuItem> */}
                                    {/* {
                                    hasRoutePermission("/create-field-schema-page") && (
                                        <MenuItem icon={<i className={`${VCARD_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Create Field schema">
                                            <a className="side-navigation-bar-menu-title" href="/create-field-schema-page">Create Field schema</a>
                                        </MenuItem>
                                    )
                                } */}
                                    {/* {hasRoutePermission('/field-schema-page') && (
                                        <MenuItem
                                            icon={
                                                <i
                                                    className={`${LIST_ICON} side-navigation-bar-icon`}
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                            title="Project Fields"
                                        >
                                            <a
                                                className="side-navigation-bar-menu-title"
                                                href="/field-schema-page"
                                            >
                                                Process Fields
                                            </a>
                                        </MenuItem>
                                    )} */}
                                </Menu>
                            </SidebarFooter>
                            <SidebarFooter>
                                    <Menu>
                                        {
                                          (hasRoutePermission('/business-vertical-page')) && (
                                            <SubMenu
                                                id="side-navigation-bar-sub-menu-user"
                                                className={
                                                    menuCollapse === true
                                                        ? `side-navigation-bar-sub-menu-user`
                                                        : ''
                                                }
                                                icon={
                                                    <BusinessIcon className="mui-side-icon"  aria-hidden="true" />
                                                }
                                                title="Corporate"
                                            >
                                               {  hasRoutePermission('/business-vertical-page') && (
                                                <MenuItem>
                                                    <a
                                                        className="side-navigation-bar-menu-title"
                                                        href="/business-vertical-page"
                                                    >
                                                        Business Vertical
                                                    </a>
                                                </MenuItem>
                                               )}
                                                {hasRoutePermission('/region-data-page') && (
                                                    <MenuItem>
                                                        <a
                                                            className="side-navigation-bar-menu-title"
                                                            href="/region-data-page"
                                                        >
                                                            Region
                                                        </a>
                                                    </MenuItem>
                                                )}
                                                <MenuItem>
                                                    <a
                                                        className="side-navigation-bar-menu-title"
                                                        href="/quotation-settings-page"
                                                    >
                                                        Quotation Settings
                                                    </a>
                                                </MenuItem>
                                            </SubMenu>
                                        )}
                                    </Menu>

                            </SidebarFooter>
                            
                        </SidebarContent>

                        <SidebarFooter>
                            <Menu>
                                <MenuItem
                                    icon={
                                        <i
                                            className={`${SIGN_OUT_ICON} side-navigation-bar-icon`}
                                            aria-hidden="true"
                                        ></i>
                                    }
                                    title="Logout"
                                    onClick={authContext.signOut}
                                >
                                    <span>Logout</span>
                                </MenuItem>
                            </Menu>
                        </SidebarFooter>
                    </ProSidebar>
                </div>
            </div>
        )
    );
}

export default SideNavigationBar;
